(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class RubyCategoryRail extends HTMLElement {
    constructor() {
      super();
      this.onDocumentClick = this.onDocumentClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.updatePanelPosition = this.updatePanelPosition.bind(this);
    }

    connectedCallback() {
      this.disclosures = Array.from(this.querySelectorAll('.ruby-category-rail__details'));
      this.disclosures.forEach((details) => {
        const summary = details.querySelector(':scope > summary');
        summary?.setAttribute('aria-expanded', details.open ? 'true' : 'false');
        details.addEventListener('toggle', () => this.onToggle(details));
      });
      document.addEventListener('click', this.onDocumentClick);
      document.addEventListener('keydown', this.onKeydown);
      window.addEventListener('resize', this.updatePanelPosition);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocumentClick);
      document.removeEventListener('keydown', this.onKeydown);
      window.removeEventListener('resize', this.updatePanelPosition);
    }

    onToggle(activeDetails) {
      const summary = activeDetails.querySelector(':scope > summary');
      summary?.setAttribute('aria-expanded', activeDetails.open ? 'true' : 'false');
      if (!activeDetails.open) return;

      this.disclosures.forEach((details) => {
        if (details !== activeDetails && details.open) {
          details.open = false;
          details.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'false');
        }
      });
      this.updatePanelPosition();
    }

    updatePanelPosition() {
      const bottom = Math.round(this.getBoundingClientRect().bottom);
      this.style.setProperty('--ruby-category-panel-top', `${bottom}px`);
    }

    onDocumentClick(event) {
      if (this.contains(event.target)) return;
      this.closeAll();
    }

    onKeydown(event) {
      if (event.key !== 'Escape') return;
      const openDetails = this.disclosures.find((details) => details.open);
      if (!openDetails) return;
      const summary = openDetails.querySelector(':scope > summary');
      openDetails.open = false;
      summary?.setAttribute('aria-expanded', 'false');
      summary?.focus();
    }

    closeAll() {
      this.disclosures.forEach((details) => {
        details.open = false;
        details.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'false');
      });
    }
  }

  if (!customElements.get('ruby-category-rail')) {
    customElements.define('ruby-category-rail', RubyCategoryRail);
  }

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ruby-campaign"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('ruby-campaign')) customElements.define('ruby-campaign',class extends HTMLElement{
    connectedCallback(){
      if(this.ready||this.dataset.layout!=='hero')return;
      this.ready=true;
      const track=this.querySelector('.ruby-campaign__track'),slides=[...track.children],count=this.querySelector('.ruby-campaign__count');
      const current=()=>{const box=track.getBoundingClientRect();return slides.reduce((best,s,i)=>Math.abs(s.getBoundingClientRect().left-box.left)<Math.abs(slides[best].getBoundingClientRect().left-box.left)?i:best,0)};
      const move=step=>{const i=(current()+step+slides.length)%slides.length;track.scrollBy({left:slides[i].getBoundingClientRect().left-track.getBoundingClientRect().left,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'})};
      if(slides.length>1)this.querySelector('.ruby-campaign__controls').hidden=false;
      this.querySelectorAll('[data-step]').forEach(b=>b.addEventListener('click',()=>move(Number(b.dataset.step))));
      track.addEventListener('keydown',e=>{if(e.target!==track||!['ArrowLeft','ArrowRight'].includes(e.key))return;e.preventDefault();move((e.key==='ArrowRight'?1:-1)*(getComputedStyle(this).direction==='rtl'?-1:1))});
      const update=()=>{const i=current();count.textContent=`${i+1} / ${slides.length}`;slides.forEach((s,n)=>s.querySelectorAll('a').forEach(a=>a.tabIndex=n===i?0:-1))};
      track.addEventListener('scroll',()=>{clearTimeout(this.timer);this.timer=setTimeout(update,120)},{passive:true});
      update();
    }
    disconnectedCallback(){clearTimeout(this.timer)}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ruby-product-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ruby-hero-carousel')) {
    customElements.define('ruby-hero-carousel', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        const track = this.querySelector('.ruby-product-hero__track');
        const slides = [...track.children];
        const count = this.querySelector('.ruby-product-hero__count');
        const rtl = getComputedStyle(this).direction === 'rtl';
        const current = () => {
          const box = track.getBoundingClientRect();
          const center = box.left + box.width / 2;
          return slides.reduce((best, slide, index) => {
            const rect = slide.getBoundingClientRect();
            const other = slides[best].getBoundingClientRect();
            return Math.abs(rect.left + rect.width / 2 - center) < Math.abs(other.left + other.width / 2 - center) ? index : best;
          }, 0);
        };
        const move = (step) => {
          const next = (current() + step + slides.length) % slides.length;
          const destination = slides[next].getBoundingClientRect();
          const viewport = track.getBoundingClientRect();
          track.scrollBy({left: destination.left - viewport.left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        };
        if (slides.length > 1) this.querySelector('.ruby-product-hero__controls').hidden = false;
        this.querySelectorAll('button[data-step]').forEach(button => button.addEventListener('click', () => move(Number(button.dataset.step))));
        track.addEventListener('keydown', event => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          move((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
        });
        track.addEventListener('scroll', () => {
          clearTimeout(this.scrollTimer);
          this.scrollTimer = setTimeout(() => { count.textContent = `${current() + 1} / ${slides.length}`; }, 120);
        }, {passive: true});
      }
      disconnectedCallback() { clearTimeout(this.scrollTimer); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
